import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\n<path d=\"M33.0371 31.9165L25.0015 39.9521L466.964 481.915L475 473.879L33.0371 31.9165Z\" fill=\"currentColor\" />\n<path d=\"M474.998 27.0357L466.962 19L24.9998 460.963L33.0355 468.998L474.998 27.0357Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol